import React from "react";
import { ManageInactiveClientsTab } from "../../../pages-via-dialog/organization-settings/tabs/manage-inactive-clients-tab/manage-inactive-clients.tab";

export const InaktiveKundenPage: React.FC = () => {
	return (
		<div className="px-12 py-6">
			<ManageInactiveClientsTab/>
		</div>
	);
};